const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#707070;}"));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M2.27,3.375a2.27,2.27,0,1,0,2.27,2.27,2.27,2.27,0,0,0-2.27-2.27Zm0,7.565a2.27,2.27,0,1,0,2.27,2.27,2.27,2.27,0,0,0-2.27-2.27Zm0,7.565a2.27,2.27,0,1,0,2.27,2.27,2.27,2.27,0,0,0-2.27-2.27Zm21.182.757H8.322a.757.757,0,0,0-.757.757v1.513a.757.757,0,0,0,.757.757h15.13a.757.757,0,0,0,.757-.757V20.018A.757.757,0,0,0,23.452,19.262Zm0-15.13H8.322a.757.757,0,0,0-.757.757V6.4a.757.757,0,0,0,.757.757h15.13a.757.757,0,0,0,.757-.757V4.888A.757.757,0,0,0,23.452,4.132Zm0,7.565H8.322a.757.757,0,0,0-.757.757v1.513a.757.757,0,0,0,.757.757h15.13a.757.757,0,0,0,.757-.757V12.453A.757.757,0,0,0,23.452,11.7Z",
  transform: "translate(0 -3.375)"
});
function SvgIconawesomeListUl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.208,
    height: 19.669,
    viewBox: "0 0 24.208 19.669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeListUl);
export default __webpack_public_path__ + "static/media/Icon awesome-list-ul.78ad843d.svg";
export { ForwardRef as ReactComponent };